import { Fade, Grid } from "@material-ui/core";
import { useEffect, useRef, useState } from "react";
import useStyles from "styles";
import useOutSideClick from "utilize/Hook/useOutSideClick";
import ArrowBackIosRoundedIcon from "@material-ui/icons/ArrowBackIosRounded";
import axios from "axios";
import Apis from "constants/Api";

export default function MultipleSelectBox({ setStateId, ids, items }) {
  const classes = useStyles();
  const [fadeOpen, setFadeOpen] = useState(false);
  const selectRef = useRef(null);
  useOutSideClick(selectRef, () => {
    setFadeOpen(false);
  });
  const handleSelected = (item, id) => {
    // console.log(item,id, ids.find((idx) => idx.index === id))
    if (ids.find((idx) => idx.index === id)) {
      const newIds = ids.filter((ft) => ft.index !== id);
      setStateId(newIds);
    } else {
      setStateId([...ids, { index: id, name: item }]);
    }
  };

  return (
    <Grid container ref={selectRef} className={classes.SelectBoxRoot}>
      <Grid
        container
        alignItems="center"
        className={classes.selectBoxContainer}
        onClick={() => {
          setFadeOpen(!fadeOpen);
        }}
      >
        {ids?.length > 0 ? ` ${ids?.length} انتخاب شده است ` : null}
        <ArrowBackIosRoundedIcon className={classes.arrowDownSelectBox} />
      </Grid>
      <Fade in={fadeOpen}>
        <Grid container className={classes.selectBoxFadeContainer}>
          {items &&
            items?.map((item, index) => {
              return (
                <Grid
                  key={index}
                  container
                  className={classes.selectBoxFadeItem}
                  onClick={() => handleSelected(item.name, item.index)}
                  style={{
                    backgroundColor: ids.find((idx) => idx.index === item.index)
                      ? "#b0d6ec"
                      : "transparent",
                  }}
                >
                  {item.name}
                </Grid>
              );
            })}
        </Grid>
      </Fade>
    </Grid>
  );
}
